import type { IconSvgObject } from './types';

const RhombusIcon: IconSvgObject = [
  ["path", { d: "M19.7959 13.3379C20.4804 12.5773 20.4804 11.4227 19.7959 10.6621L13.4866 3.65176C12.6921 2.769 11.3079 2.76901 10.5134 3.65177L4.20414 10.6621C3.51959 11.4227 3.51959 12.5773 4.20414 13.3379L10.5134 20.3482C11.3079 21.231 12.6921 21.231 13.4866 20.3482L19.7959 13.3379Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default RhombusIcon;
